import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4becee9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-card-date d-flex justify-content-between" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "pr-3 d-flex align-items-center text-size-18 font-weight-bold" }
const _hoisted_4 = { class: "d-flex align-items-center text-size-18 font-weight-bold" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-end text-size-10 pl-1"
}
const _hoisted_6 = { class: "text-size-18 py-1" }
const _hoisted_7 = { class: "text-size-14 py-1" }
const _hoisted_8 = { class: "text-size-12 py-1" }
const _hoisted_9 = {
  key: 1,
  class: "py-1"
}
const _hoisted_10 = { class: "d-flex w-100 text-size-12" }
const _hoisted_11 = { class: "d-inline-block" }
const _hoisted_12 = { class: "d-flex w-100 mt-2 text-size-12" }
const _hoisted_13 = { class: "d-inline-block" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-end pt-1" }
const _hoisted_15 = { class: "d-flex align-items-end" }
const _hoisted_16 = { class: "text-red" }
const _hoisted_17 = {
  key: 0,
  class: "text-size-10 text-mild pl-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_BBadge = _resolveComponent("BBadge")!

  return (_openBlock(), _createElementBlock("div", {
    class: "order-card bg-white border border-outline-color",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickCard && _ctx.onClickCard(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createVNode(_component_FeatherIcon, {
            icon: "calendar",
            size: "1x",
            class: "mr-1"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.getFormattedDate(_ctx.order)), 1)
        ]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_FeatherIcon, {
            icon: "clock",
            size: "1x",
            class: "mr-1"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.formattedWorkTimeRange), 1)
        ]),
        _createTextVNode(),
        (_ctx.isWorkFixed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "\n          [確定]\n        "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createTextVNode(),
    (!_ctx.isSimpleDisplay)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.order.office.name), 1),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.order.address), 1),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.order.title), 1)
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (!_ctx.isAppliedPage && _ctx.isSimpleDisplay)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_FeatherIcon, {
              icon: "map-pin",
              size: "14",
              class: "flex-shrink-0 map-icon mr-1"
            }),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.order.address), 1)
          ]),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_FeatherIcon, {
              icon: "navigation",
              size: "14",
              class: "flex-shrink-0 map-icon mr-1"
            }),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.order.access), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.salaryPerDayWithVariousAllowances) + "円\n        ", 1),
        _createTextVNode(),
        (_ctx.isWorkFixed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, "\n          [確定]\n        "))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      (_ctx.badgeAttr)
        ? (_openBlock(), _createBlock(_component_BBadge, {
            key: 0,
            variant: _ctx.badgeAttr.bgColor,
            class: _normalizeClass(["text-size-14 text-weight-400 p-2", `text-${_ctx.badgeAttr.color}`])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.badgeAttr.text), 1)
            ], undefined, true),
            _: 1
          }, 8, ["variant", "class"]))
        : _createCommentVNode("", true)
    ])
  ]))
}